import React, { useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Avatar,
  Text,
  FormLabel,
  Icon,
  useToast,
} from "@chakra-ui/react";
import { FiUploadCloud } from "react-icons/fi";
import { getImageUrls } from "../../../../../utils/helpers";

function SelectCompanyLogo({
  setImage,
  image,
  heading,
  isViewOnly = false,
  required = true,
}) {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const toast = useToast();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    return;
    if (file && file.size > 10 * 1024 * 1024) {
      toast({
        title: "File too large.",
        description: "Max file size is 10MB.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (file && file.type.startsWith("image/")) {
      const img = new Image();
      const reader = new FileReader();
      reader.onloadend = () => {
        img.onload = () => {
          if (img.width >= 400 && img.height >= 400) {
            setPreview(reader.result);
            setImage(reader.result);
            // console.log("Image uploaded successfully", reader.result);
          } else {
            toast({
              title: "Image too small.",
              description: "Minimum dimensions are 400x400px.",
              status: "warning",
              duration: 3000,
              isClosable: true,
            });
          }
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = () => {
    setPreview(null);
    fileInputRef.current.value = "";
  };
  const AvatarImg = useMemo(() => {
    return (
      <Avatar
        size="lg"
        src={
          getImageUrls(
            Array.isArray(image) ? image : [image],
            true,
            true,
          )?.[0] || ""
        }
        bg="gray.200"
      />
    );
  }, [image]);

  // console.log("Image", image, );
  return (
    <Flex gap={4} align="flex-start">
      {AvatarImg}

      <Box>
        <FormLabel mb={1}>
          {heading ? heading : "Company Logo"}{" "}
          {required && (
            <Text as="span" color="red.500">
              *
            </Text>
          )}
        </FormLabel>
        <Flex gap={2}>
          {!isViewOnly && (
            <Button
              leftIcon={<Icon as={FiUploadCloud} />}
              size="sm"
              variant="outline"
              onClick={() => fileInputRef.current.click()}
            >
              Upload image
            </Button>
          )}
          {preview && (
            <Button
              size="sm"
              variant="ghost"
              colorScheme="red"
              onClick={handleRemove}
            >
              Remove
            </Button>
          )}
        </Flex>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/png, image/jpeg, image/webp"
          hidden
          onChange={handleImageChange}
        />
        <Text fontSize="xs" color="gray.500" mt={1}>
          *png, *jpeg files up to 10MB atleast 400Px*400Px
        </Text>
      </Box>
    </Flex>
  );
}

export default React.memo(SelectCompanyLogo);
